import React, { Component } from 'react';
import { connect } from 'react-redux';
import { socketConnect } from 'socket.io-react';
import FacebookLogin from 'react-facebook-login';
import GoogleLogin from 'react-google-login';
import PropTypes from 'prop-types';
import { browserHistory, Link } from 'react-router';
import { userLogin } from 'store/user';
import Modal from 'components/Modal';
import InputValidation from 'components/InputValidation';
import { spin, stop } from 'store/spinner';
import LogoImage from 'assets/Basiligo-Logo.png';
import LogoIcon from 'assets/logo-icon.png';
import AndroidImage from 'assets/andriod-app.png';
import AppleImage from 'assets/apple-app.png';
import LogoImageIcon from 'assets/b-logo-icon.png';
import PhoneInput from 'components/PhoneInput';
import DietPlanIcon from 'assets/diat-plan.gif';
import { getCountryCallingCode } from 'react-phone-number-input';

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      validateType: 'phone',
      password: '',
      smscode: '',
      showsms: false,
      errorModalMessage: '',
      showPassword: false,
      errors: {},
      xyz: false,
      otp: ['','','',''],
      step: 1,         // 1 = enter contact, 2 = enter OTP
      timer: 0,        // countdown timer
      intervalId: null, // stores interval for clearing,
      phone:'',
      emailMode:'otp',
      PC_CODE:'+971',
    };
    this.otpInputs = [];
  }

  socketLogin = ({ type, data, message, banned, smscode }) => {
    this.props.stop();
    if (this.OtpAuthRef) {
       switch (type) {
          case 'otpErr':
          case 'otpverifyErr':
          case 'setErr':
            this.setState({
              errorModalMessage: message,
            });
          break;
          case 'createAccountErr':
            this.setState({ errors: data });
          break;
          case 'otpOk':
            this.setState({
              step:2
            });
            this.startTimer();
          break;
          case 'otpverifyOk':
            clearInterval(this.state.intervalId);
            const ndata = {
              ...data,
              isLoggedIn: true
            };
            this.props.login(ndata);
            const { location } = this.props;
            const { redirect } = location.query;
            if(redirect){
              browserHistory.push('/'+redirect);
            }else{
              browserHistory.push('/');
            }
          break;
          case 'setOk':
            this.props.login(data);
            browserHistory.push('/');
          break;
        }
      }
  };

  componentWillMount() {
    this.props.socket.on('login', this.socketLogin);
  }

  componentWillUnmount() {
    this.props.socket.removeListener('login', this.socketLogin);
  }

  componentDidMount() {
    setTimeout(() => this.setState({ xyz: true }), 10);
  }

  submit(e, browserId) {
     e.preventDefault();
        const { email, otp,step, validateType,PC_CODE,emailMode } = this.state;
        let phone =this.state.phone ;
        if((step==1 || step==4)&&emailMode!='password'){
            let contact = (validateType=='email')?email:phone;
            if(step==4){
              this.setState({otp:['','','','']});
            }
            this.sendOtp(validateType,contact,PC_CODE,browserId);
        }else if(step==2){
          this.verifyOtp(browserId);
        }else if(emailMode=='password'){
          const { password } = this.state;
          this.props.socket.emit('login', { type: 'set', data: { email, password, browserId, app: 'customer'} });
        }
    // console.log('Login Trigger');
  // alert("Our website is temporarily down for maintenance to improve your experience");
  // return false;
    // this.props.socket.emit('login', { type: 'set', data: { email, password, browserId, app: 'customer', smscode: smscode } });
  }

  submitFacebook(response, browserId) {
    if ('id' in response) {
      this.props.socket.emit('login', { type: 'facebook', data: { ...response, browserId }, app: 'customer' });
    }
  } 

  submitGoogle(response, browserId) {
    this.props.socket.emit('login', { type: 'google', data: { ...response, browserId }, app: 'customer' });
  }
  // handleOtpChange = (name,value) => {
  //   const val = value.replace(/[^0-9]/g, '').slice(0, 4);
  //   this.setState({ otp: val});
  // };
  handleOtpChange = (value, index) => {
  const { otp } = this.state;
  const otpLength = otp.length;

  // Remove non-numeric chars
  const cleanValue = value.replace(/\D/g, '');

  // 🚀 FULL OTP PASTE
  if (cleanValue.length === otpLength) {
    const newOtp = cleanValue.split('');

    this.setState({ otp: newOtp }, () => {
      this.otpInputs[otpLength - 1].focus();
    });

    return;
  }

  // 🚀 Partial paste
  if (cleanValue.length > 1) {
    const newOtp = [...otp];

    cleanValue.split('').forEach((digit, i) => {
      if (index + i < otpLength) {
        newOtp[index + i] = digit;
      }
    });

    this.setState({ otp: newOtp }, () => {
      const nextIndex = Math.min(
        index + cleanValue.length,
        otpLength - 1
      );
      if (this.otpInputs[nextIndex]) {
        this.otpInputs[nextIndex].focus();
      }
      
    });

    return;
  }

  // 🚀 Single digit input
  if (/^\d?$/.test(cleanValue)) {
    const newOtp = [...otp];
    newOtp[index] = cleanValue;

    this.setState({ otp: newOtp }, () => {
      if (cleanValue && index < otpLength - 1 && this.otpInputs[index + 1]) {
        this.otpInputs[index + 1].focus();
      }
    });
  }
};

  handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !this.state.otp[index] && index > 0) {
      this.otpInputs[index - 1].focus(); // move back if empty
    }
  };
   startTimer = () => {
    const intervalId = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.timer <= 1) {
          clearInterval(this.state.intervalId);
          return { timer: 0, intervalId: null,step:4 };
        }
        return { timer: prevState.timer - 1 };
      });
    }, 1000);
    this.setState({ timer: 300, intervalId });
  };
  sendOtp = (validateType,contact,PC_CODE,browserId) => {
    try {
      this.props.spin();
      this.props.socket.emit('login', { type: 'otp', data: { validateType,contact,PC_CODE, app: 'customer',browserId } });
      // this.setState({ step: 2 });
      
    } catch (error) {
      alert('Failed to send OTP');
    }
  };

  verifyOtp = (browserId) => {
    try {
      const { otp,validateType,email,phone,PC_CODE } = this.state;
      let contact = (validateType=='email')?email:phone;
      this.props.spin();
      this.props.socket.emit('login', { type: 'otpverify', data: { validateType,contact,otp:otp.join(''),PC_CODE:PC_CODE, app: 'customer',browserId } });
    } catch (error) {
      alert('Error verifying OTP');
    }
  };
  render() {
    const onChange = (name, value) => this.setState({ [name]: value });
    const onPhoneChange = (name, value) =>{
      this.setState({ [name]: value });
    };
    const { errors, errorModalMessage, email, password, xyz, showsms, smscode, step,otp,timer,PC_CODE, phone,validateType,emailMode } = this.state;
    const { settings, browserId,stop } = this.props;
    // const facebookAppId = settings.getValue('FACEBOOK_APP_ID');
    // const googleAppId = settings.getValue('GOOGLE_APP_ID');
    const facebookAppId = '';
    const googleAppId = '';
    //console.log(browserId);
    let buttonText = (step==1)?(validateType=='email'&&emailMode=='password')?'Login':'Get OTP':((step==2)?'Verify OTP':((step==4)?'Resend OTP':'Login'));
    
    return (
      <div ref={el => (this.OtpAuthRef = el)} className='full-width'>
        <div className='sign-container'>
        <div className='sign-b-left'>           
            {/* <div className='logo-icon'>  <Link to='/' onClick={() => stop()} onlyActiveOnIndex><img src={LogoImageIcon} alt='Basiligo' /></Link></div> */}
            <div className={`sign-up-form otp-login ${validateType=='email' ? 'email-login' : ''}`}>
              <div className='logo mb-4'> <img src={LogoIcon} alt='Basiligo' className='img-logo' /></div> 
              <div className='search-title mt-1 mb-3'>
                <h1>Clean Eating Meal Plans</h1>
                <h3>Login to access & change the menu options</h3>
              {/* <span className='colorTitle'>Sign In</span> */}
              {/* <Link to='/sign-up' className='colorTitle ml-3'>Sign Up</Link> */}
              </div>
               <div className='sign-in-top mt-3'>
                {validateType=='phone'?<span className={`colorTitle`}>Phone</span>:<a href="javascript:void(0);" className={`colorTitle`} onClick={()=>{ this.setState({validateType:'phone',email:'',step:1})}}>Phone</a>}
                {validateType=='email'?<span className={`colorTitle ml-3`}>Email</span>:<a href="javascript:void(0);" className={`colorTitle ml-3`} onClick={()=>{ this.setState({validateType:'email',phone:'',step:1})}}>Email</a>}
                </div>
              <form className='form' onSubmit={e => this.submit(e, browserId)}>
                <div className='sign-form-container'>
               {(validateType=='email' ||step==3) && <div className='sign-up-input mt-3 email-field'><label className="textLeft mb-2">Email</label>
                    <InputValidation
                      value={email}
                      name='email'
                      onChange={onChange}
                      placeholder='Your Email'
                      errors={errors}
                      inputSelfClassName='standart-input b-rounded-blue'
                    />
                  </div>}
                {((validateType=='email'&& emailMode=='password')) &&<div className='sign-up-input mt-4 pwd-field'><label class="textLeft mb-2">Password</label>
                                                      <InputValidation
                                                        type='password'
                                                        name='password'
                                                        value={password}
                                                        onChange={onChange}
                                                        placeholder='Your Password'
                                                        errors={errors}
                                                        inputSelfClassName='standart-input b-rounded-blue'
                                                      />
                                                    </div>}
                 {(validateType=='phone' ||step==3) && <div className='sign-up-input mt-3 additional-number'><label className="textLeft mb-2">Phone Number</label>
                  <PhoneInput
                      errors={errors}
                      labelText={'Calling Number'}
                      classError='has-error letter-xs'
                        phoneProps={{ 
                              value:(PC_CODE!=null && PC_CODE!=undefined && phone!=undefined)?PC_CODE+(phone.replace(PC_CODE,'')):phone,
                              defaultCountry:"AE",
                              className:'standart-input b-rounded-blue',
                              // labels:{'phone':'Calling Number'},
                              name:'phone',
                              international:true,
                              placeholder:'Calling Number',
                              countryCallingCodeEditable:false,
                               onCountryChange:(val)=>{
                                if(val){
                                  const callingCode = getCountryCallingCode(val);
                                  this.setState({PC_CODE:'+'+callingCode})
                                }
                              },
                              onChange:(value) => onPhoneChange('phone', value)
                        }}
                      /></div>}
                  {step==2 && <div className='sign-up-input mt-3 email-field'><label className="textLeft mb-2">Enter OTP</label>
                    <div style={{ display: "flex", gap: "10px" }}>
                        {this.state.otp.map((digit, idx) => (
                          <input
                            key={idx}
                            className="standart-input b-rounded-blue"
                            ref={(el) => (this.otpInputs[idx] = el)}
                            type="text"
                            maxLength={otp.length}
                            value={digit}
                            onChange={(e) => this.handleOtpChange(e.target.value, idx)}
                            onKeyDown={(e) => this.handleKeyDown(e, idx)}
                            style={{
                              width: "50px",
                              height: "50px",
                              textAlign: "center",
                              fontSize: "24px"
                            }}
                          />
                        ))}
                      </div>
                  </div>}
                   
                  </div>
                <div className='search-title login-text mt-3'>
                <p className='line-height-xsnormal login-text mb-0'>
                  By signing in or signing up, I agree to Basiligo &nbsp;
                  <Link to='/terms' >Terms & Conditions</Link>, <Link to='/refunds' >Refund & Cancellation policy</Link>, <Link to='/privacy-policy' >Privacy Policy</Link>,
                  I confirm that I am 18 years of age or older, and consent to receiving email communication.
                </p>
                </div>
                {/* <div className='login-text mt-3  text-right'>
                  <span><Link to='/restore'>Forgot password?</Link></span>
                </div></div> */}
                <div className='sign-up-input mt-4 sign-up-button d-flex align-items-center justify-content-around'>
                  <input type='submit' value={buttonText} className='form-button letter-sm w-100' />
                    {timer > 0 && `Wait ${timer}s`}
                </div>
                
              </form>
              {validateType=='email' && <div className='mt-2 bottom-con'>
                <p className='center'>Or</p>
                <p
                    className="switch-link"
                    onClick={() =>
                      this.setState({ emailMode:(emailMode === "otp" ? "password" : "otp")})
                    }
                  >
                    {emailMode === "otp"
                      ? "Login with Password"
                      : "Login with OTP"}
                  </p></div>}
                  {/* <div className='build-link'>
                  <Link to='/meal-plans' >Build Your Plan & View your Meals</Link>
                </div> */}
              {/*<div className='search-title login-text mt-3'>
                <span className='colorTitle letter-sm'>Or</span>
        </div>*/}
              {googleAppId && <GoogleLogin
                clientId={googleAppId}
                onSuccess={response => this.submitGoogle(response, browserId)}
                buttonText='Sign in with Google'
                className='sign-up-input mt-3 sign-up-button-google d-flex align-items-center justify-content-around'
                onFailure={data => console.log(data)}
              />}
              {facebookAppId && <FacebookLogin
                appId={facebookAppId}
                size='small'
                callback={response => this.submitFacebook(response, browserId)}
                fields='name,email,picture,first_name,last_name'
                textButton='Sign in with Facebook'
                cssClass='sign-up-input mt-3 mb-2 sign-up-button-facebook d-flex align-items-center justify-content-around'
              />}
              {/* <div className='mt-4 mr-1 text-center sign-up-bottom'>
            <span className='mt-1 mr-1'>Don’t have an Account? </span>
              <span className='login-text'><Link to='/sign-up'>Create your Account</Link></span>
              </div> */}
            </div>
            {errorModalMessage &&
              <Modal
                close={() => this.setState({ errorModalMessage: '' })}
                message={errorModalMessage}
              />
            }
        </div>
        <div className={`sign-b-right`}>
            <div className='sign-b-right-details'><h2>Plan First, Eat Smart</h2>
            <h6>Explore your menu, select your dishes, and discover new healthy favorites —<br/><strong>all before you subcribe.</strong></h6>
            <ul className='login-list'>
              <li>Preview every meal</li>
              <li>Personalize your plan</li>
              <li>Full ingredient transparency</li>
            </ul>
            <div className='app-store-gpay'>
                <Link to='https://apps.apple.com/bg/app/basiligo-meal-plan/id6496685190' ><img className='img-play' src={AppleImage} alt='Basiligo Apple Store' /></Link>
              <Link to='https://play.google.com/store/apps/details?id=com.basiligo.basiligomobileapp' ><img className='img-app' src={AndroidImage} alt='Google Play Store' /></Link>
            </div>
            <h6 className='applink-head'>Download the Basiligo App to Get Started</h6>
            </div>
      </div>
      </div>
      </div>
    );
  }
}

SignIn.propTypes = {
  socket: PropTypes.object.isRequired,
  settings: PropTypes.object,
  browserId: PropTypes.string,
  login: PropTypes.func.isRequired
};

const props = state => ({
  browserId: state.user.browserId,
  language: state.user.language,
  settings: state.settings
});

const actions = dispatch => ({
  login: user => dispatch(userLogin(user)),
  spin: () => dispatch(spin()),
  stop: () => dispatch(stop()),
});

export default socketConnect(connect(props, actions)(SignIn));
